// extracted by mini-css-extract-plugin
export default {"image":"image___d1ebd74d9ccb43158335","head":"head___e50491076a2b6391ab9a","buttonWrap":"buttonWrap___d46af12a2024e65ab534","button":"button___a814c0ee504535151ba8"};